class UploadedFilesService {
	private uploadedFileIds = new Map<string, string>();
	private cloudFileIdsToDelete: string[] = [];

	constructor() {}

	public addFileId(fileId: string, cloudFileId: string): void {
		this.uploadedFileIds.set(fileId, cloudFileId);
	}

	public removeFileId(fileId: string): void {
		const cloudFileId = this.uploadedFileIds.get(fileId);

		if (cloudFileId) {
			this.addCloudFileIdToDelete(cloudFileId);
		}

		this.uploadedFileIds.delete(fileId);
	}

	public hasFileId(fileId: string): boolean {
		return this.uploadedFileIds.has(fileId);
	}

	public getCloudFileId(fileId: string): string | undefined {
		return this.uploadedFileIds.get(fileId);
	}

	public getCloudFileIdsToDelete(): string[] {
		return this.cloudFileIdsToDelete;
	}

	public removeCloudFileIdToDelete(cloudFileId: string): void {
		this.cloudFileIdsToDelete = this.cloudFileIdsToDelete.filter((id) => id !== cloudFileId);
	}

	public addCloudFileIdToDelete(cloudFileId: string): void {
		this.cloudFileIdsToDelete = [...this.cloudFileIdsToDelete, cloudFileId];
	}
}

export const UPLOADED_FILES_SERVICE = new UploadedFilesService();
